import { get } from '@/service/Axios'
import { TokenService } from '@/service/Storage.Service'

const SETTINGS_LABELS = ['Pegawai', 'Kategori Pegawai', 'Konfigurasi']

export const DEFAULT_MENU = [
  {
    id: 1,
    label: 'CoA',
    icon: 'mdi-file-cog',
    link: '/coa',
    color: 'primary',
    action: {
      add: true,
      update: true,
      delete: true,
      export: true,
      add_sub: true
    }
  },
  {
    id: 52,
    label: 'Set Saldo Awal',
    icon: 'mdi-currency-usd',
    link: '/set-saldo-awal',
    color: 'pink',
    action: []
  },
  {
    id: 4,
    label: 'Jurnal',
    icon: 'mdi-file-document-edit-outline',
    color: 'warning',
    link: '/jurnal',
    action: {
      add: true,
      list_template: true,
      delete_verification: true,
      varification: true,
      update: true
    }
  },
  {
    id: 5,
    label: 'Buku Besar',
    icon: 'mdi-book-open-blank-variant',
    link: '/buku-besar',
    color: 'success',
    action: {
      export: true
    }
  },
  {
    id: 2,
    label: 'Neraca',
    icon: 'mdi-scale-balance',
    link: '/neraca',
    color: 'accent',
    action: {
      export: true
    }
  },
  {
    id: 3,
    label: 'Laba Rugi',
    icon: 'mdi-chart-bell-curve-cumulative',
    link: '/laba-rugi',
    color: 'pink',
    action: {
      export: true
    }
  },
  {
    id: 6,
    label: 'Tutup Buku',
    icon: 'mdi-book-remove',
    link: '/trial-balance',
    color: '#3E2723',
    action: {
      buka_buku: true,
      tutup_buku: true
    }
  },
  {
    id: 7,
    label: 'Project',
    icon: 'mdi-folder-account',
    link: '/project',
    color: '#00838F',
    action: {
      add: true,
      update: true,
      delete: true,
      add_rencana: true,
      delete_rencana: true,
      export: true,
      add_report_rencana: true,
      delete_report_rencana: true
    }
  },
  {
    id: 14,
    label: 'Vendor',
    icon: 'mdi-home-account',
    link: '/vendor',
    color: '#00838F',
    action: {
      add: true,
      update: true,
      delete: true,
      add_rencana: true,
      export: true,
      delete_rencana: true,
      add_report_rencana: true,
      delete_report_rencana: true,
      add_project: true,
      delete_project: true
    }
  },
  {
    id: 8,
    label: 'Divisi',
    icon: 'mdi-bookmark-box',
    link: '/divisi',
    color: '#BF360C',
    action: {
      add: true,
      update: true,
      delete: true,
      add_rencana: true,
      delete_rencana: true,
      export: true,
      add_report_rencana: true,
      delete_report_rencana: true
    }
  },
  {
    id: 53,
    label: 'Laporan Sub Keuangan',
    icon: 'mdi-file-document',
    link: '/laporan-sub-keuangan',
    color: '#827717',
    action: {
      export: true
    }
  },
  {
    id: 9,
    label: 'Audit Trail',
    icon: 'mdi-list-box',
    link: '/audit',
    color: '#455A64',
    action: {
      export: true
    }
  },
  {
    id: 10,
    label: 'Kelola Jurnal',
    icon: 'mdi-archive-edit',
    link: '/manage-jurnal',
    color: 'red',
    action: {}
  },
  {
    id: 11,
    label: 'Pegawai',
    icon: 'mdi-account-group',
    link: '/user',
    color: 'primary',
    action: {
      add: true,
      update: true,
      delete: true,
      export: true,
      reset_password: true
    }
  },
  {
    id: 12,
    label: 'Kategori Pegawai',
    icon: 'mdi-shape',
    link: '/category-user',
    color: '#4A148C',
    action: {
      add: true,
      update: true,
      delete: true
    }
  },
  {
    id: 13,
    label: 'Konfigurasi',
    icon: 'mdi-cog-outline',
    link: '/config',
    color: 'black',
    action: {}
  }
]

export function resolveMenuFromAccount (accountData) {
  const menuArr = accountData?.cat_menu_array
  if (!menuArr || menuArr.length < 1) {
    return DEFAULT_MENU
  }
  return menuArr
}

export function splitMenuBySection (menu = []) {
  const akunting = []
  const settings = []

  menu.forEach((item) => {
    if (SETTINGS_LABELS.includes(item.label)) {
      settings.push(item)
    } else {
      akunting.push(item)
    }
  })

  return { menu: akunting, settings }
}

export async function syncMenuAccess (store) {
  const response = await get('account/data')
  const res = response.data

  if (res.status !== 200) {
    return null
  }

  const accountData = res.results.data
  const menu = resolveMenuFromAccount(accountData)
  const user = {
    ...store.state.user,
    ...accountData
  }

  TokenService.saveToken(
    store.state.token,
    JSON.stringify(user),
    JSON.stringify(menu)
  )
  store.commit('setUser', user)
  store.commit('setMenu', menu)

  return splitMenuBySection(menu)
}
